'use strict';

module.exports = require('./Switch');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.1.4.4@rc-switch/lib/index.js
 ** module id = 395
 ** module chunks = 0 1
 **/